import type { Project } from '@bcl/shared';
import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { toast } from 'sonner';
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from '@/components/ui/card';
import { ProjectWizard } from '@/features/projects/wizard';
import { statusLabels } from '@/features/projects/labels';
import { getProject } from '@/features/projects/projects-api';
import { extractErrorMessage } from '@/features/auth/error-message';

export function ProjectWizardPage() {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const [project, setProject] = useState<Project | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    getProject(id as string)
      .then(setProject)
      .catch((e) => setError(extractErrorMessage(e)));
  }, [id]);

  if (error) {
    return (
      <main className="container py-12" role="alert">
        <p className="text-destructive">{error}</p>
      </main>
    );
  }

  if (!project) {
    return (
      <main className="container py-12">
        <p className="text-muted-foreground">Chargement du projet…</p>
      </main>
    );
  }

  return (
    <main className="container py-12">
      <Card className="mx-auto max-w-3xl">
        <CardHeader>
          <CardTitle>Projet {project.reference}</CardTitle>
          <CardDescription>
            Statut : {statusLabels[project.status]}
          </CardDescription>
        </CardHeader>
        <CardContent>
          <ProjectWizard
            project={project}
            onUpdated={setProject}
            onCompleted={(p) => {
              toast.success(
                'Votre dossier est en cours de vérification BCL. Vous pouvez maintenant déposer vos documents.',
              );
              navigate(`/projects/${p.id}`);
            }}
          />
        </CardContent>
      </Card>
    </main>
  );
}
